export default __webpack_public_path__ + "static/media/image-about-hero.cd9299f7.jpg";